module.exports = __webpack_public_path__ + "static/media/more-information.1ae932d0.png";